module.exports = __webpack_public_path__ + "static/media/Runway27.74109d18.glb";